import React, { FunctionComponent } from 'react';

import University from '../../../../networking/models/University';
import Card from '../../../layout/Card';
import defaultImage from '../../../../assets/images/no_image_available.jpg'

import { ReactComponent as PlusIcon } from '../../../../assets/icons/icon_plus.svg';
import { ReactComponent as EditIcon } from '../../../../assets/icons/icon_edit.svg';
import SocialMediaIcon from './SocialMediaIcon';

interface Props {
    university: University;
    onClick: (university: University) => void;
    onDeleteClick: (university: University) => void;
}

const UniversityCard: FunctionComponent<Props> = ({ university, onClick, onDeleteClick }) => {

    const onMediaIconClick = (url: string) => {
        window.open(url, '_blank');
    };

    const onEditIconClick = () => onClick(university);
    const onDeleteIconClick = () => onDeleteClick(university);

    const uniImg = university.images?.length === 0 ? defaultImage : university.images![0].url;

    return (
        <Card className={'admin-university-card'}>
            <div className="admin-university-card__image" style={{ backgroundImage: `url(${uniImg})` }}></div>

            <div className="admin-university-card__info">
                <p className={'admin-university-card__title'}>{ university.name }</p>

                {/* <Rating rating={university.rating!} size={'small'} sideText={`(${university.responses} responses)`} /> */}

                <p className={'admin-university-card__text'}>{ university.country?.name }</p>
                <p className={'admin-university-card__text'}>{ university.city }</p>
                <p className={'admin-university-card__text'}>{ university.responses } Responses</p>
            </div>

            <div className="admin-university-card__desc">
                <p className={'university-card__text'}>{ university.description }</p>

                <div className={'admin-university-card__media'}>
                    { university.socialMediaAccounts?.map(account => ( // TODO: replace with MediaAccountList
                        <SocialMediaIcon
                            name={account.slug}
                            className={'admin-university-card__media-icon'}
                            onClick={() => onMediaIconClick(account.url)}
                            key={account.slug} />
                    )) }
                </div>
            </div>

            <div className="admin-university-card__actions">
                <div className={'admin-university-card__action-box'}>
                    <EditIcon className={'admin-university-card__icon admin-university-card__icon--edit'} onClick={onEditIconClick} />
                </div>

                <div className={'admin-university-card__action-box admin-university-card__action-box--delete'}>
                    <PlusIcon className={'admin-university-card__icon admin-university-card__icon--delete'} onClick={onDeleteIconClick} />
                </div>
            </div>
        </Card>

    );
};

export default UniversityCard;
